import { render, staticRenderFns } from "./dev.vue?vue&type=template&id=0c7a1de6&"
import script from "./dev.vue?vue&type=script&lang=ts&"
export * from "./dev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports